import api from '../../../api/apibackend';
import { GET_TICKET_USERS } from './actions.type'
import { FETCH_START, FETCH_END, SET_USERS } from './mutations.type'

const state = {
  loading: false,
  users: []
}

const getters = {
  ticketUsers: state => state.users,
  loading: state => state.loading
}

const mutations = {
  [FETCH_START](state) {
    state.loading = true
  },
  [FETCH_END](state) {
    state.loading = false
  },
  [SET_USERS](state, payload) {
    state.users = payload
  }
}

const actions = {
  async [GET_TICKET_USERS]({ commit }) {
    try {
      commit(FETCH_START)
      const res = await api.get(`ticket/ticket-users`);
      commit(SET_USERS, res.data)
      commit(FETCH_END)
    } catch (err) {
      commit(FETCH_END)
      console.log(err)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
